import { render } from "./ExcerciseTestResult2.vue?vue&type=template&id=094f9baa&scoped=true"
import script from "./ExcerciseTestResult2.vue?vue&type=script&lang=js"
export * from "./ExcerciseTestResult2.vue?vue&type=script&lang=js"

import "./ExcerciseTestResult2.vue?vue&type=style&index=0&id=094f9baa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094f9baa"]])

export default __exports__